// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"dc53e6547e32a77f","270":"a96f6b27b79bfdd1","717":"c3c265944fde31b7","796":"19778ded86901a77"}[chunkId] + ".js";
};